export const extensionSlots = {
	aiAgentConfigContextDemoExtension:
		'urn:sfextslot:pilet:ai-agent-config-context-demo-extension' as const,
	aiAgentConfigsExtension:
		'urn:sfextslot:safregistry:ai-agent-configs-extension' as const,
};

export interface EmptyParams {}

export interface AiAgentConfigsExtensionParams {
	submitEventName: string;
	onSaved?: (success: boolean, error?: any) => void;
	onFetchError?: (error: any) => void;
}

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		[extensionSlots.aiAgentConfigContextDemoExtension]: EmptyParams;
		[extensionSlots.aiAgentConfigsExtension]: AiAgentConfigsExtensionParams;
	}
}
